import React, { useRef, useEffect, useState } from 'react';
import AirToOceanSection from './AirOceanSection';
import CertGridSection from './CertGridSection';
import FreightPhilosophy from './FreightPhilosophy';
import RouteForwardSection from './RouteForwardSection';
import AboutHero from './Hero';
import Globe from '../Globe';
import Navbar from '../Navbar';
import Footer from '../Footer';

const AboutPage = () => {
  const sectionRefs = {
    aboutHero: useRef(null),
    airOcean: useRef(null),
    certGrid: useRef(null),
    globe: useRef(null),
    freight: useRef(null),
    route: useRef(null),
    footer: useRef(null),
  };

  const sectionOrder = [
    { key: 'aboutHero', color: '#86cde9' },
    { key: 'airOcean', color: '#86cde9' },
    { key: 'certGrid', color: '#86cde9' },
    { key: 'globe', color: '#02044f' },
    { key: 'freight', color: '#02044f' },
    { key: 'route', color: '#02044f' },
    { key: 'footer', color: '#02044f' }
  ];

  const [bgColor, setBgColor] = useState('#86cde9');

  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  const interpolateColor = (c1, c2, factor) => {
    return {
      r: Math.round(c1.r + (c2.r - c1.r) * factor),
      g: Math.round(c1.g + (c2.g - c1.g) * factor),
      b: Math.round(c1.b + (c2.b - c1.b) * factor),
    };
  };

  const rgbToHex = ({ r, g, b }) => {
    return `#${[r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')}`;
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY + window.innerHeight * 0.3;

      for (let i = 0; i < sectionOrder.length - 1; i++) {
        const ref1 = sectionRefs[sectionOrder[i].key].current;
        const ref2 = sectionRefs[sectionOrder[i + 1].key].current;

        if (!ref1 || !ref2) continue;

        const start = ref1.offsetTop;
        const end = ref2.offsetTop;

        if (scrollY >= start && scrollY < end) {
          const progress = (scrollY - start) / (end - start);
          const color1 = hexToRgb(sectionOrder[i].color);
          const color2 = hexToRgb(sectionOrder[i + 1].color);
          const blended = interpolateColor(color1, color2, progress);
          setBgColor(rgbToHex(blended));
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [sectionRefs]);

  return (
    <div className="overflow-hidden relative">
      {/* Background Layer */}
      <div
        className="fixed inset-0 z-[-1] transition-all duration-700 ease-in-out"
        style={{ backgroundColor: bgColor }}
      />
      <Navbar currentBgColor={bgColor} />
      <div className="relative z-10">
        <div ref={sectionRefs.aboutHero}><AboutHero /></div>
        <div ref={sectionRefs.airOcean}><AirToOceanSection /></div>
        <div ref={sectionRefs.certGrid}><CertGridSection /></div>
        <div ref={sectionRefs.globe}><Globe /></div>
        <div ref={sectionRefs.freight}><FreightPhilosophy /></div>
        <div ref={sectionRefs.route}><RouteForwardSection /></div>
        <div ref={sectionRefs.footer}><Footer /></div>
      </div>
    </div>
  );
};

export default AboutPage;
